import mailGatewaySlice from "../slices/mailGatewaySlice";

export const {
  RequestDistinctHosts,
  SuccessDistinctHosts,
  FailureDistinctHosts,
  RequestDistinctLiveHosts,
  SuccessDistinctLiveHosts,
  FailureDistinctLiveHosts,
  RequestAnalyzedEmails,
  SuccessAnalyzedEmails,
  FailureAnalyzedEmails,
  RequestBlockedEmails,
  SuccessBlockedEmails,
  FailureBlockedEmails,
  RequestUnblockedEmails,
  SuccessUnblockedEmails,
  FailureUnblockedEmails,
  RequestReleaseEmail,
  SuccessReleaseEmail,
  FailureReleaseEmail,
  RequestSetMailTransferSettings,
  SuccessSetMailTransferSettings,
  FailureSetMailTransferSettings,
  RequestGetMailTransferSettings,
  SuccessGetMailTransferSettings,
  FailureGetMailTransferSettings,
  RequestGetWhitelistSettings,
  SuccessGetWhitelistSettings,
  FailureGetWhitelistSettings,
  RequestSetWhitelistSettings,
  SuccessSetWhitelistSettings,
  FailureSetWhitelistSettings,
  RequestGetBlacklistSettings,
  SuccessGetBlacklistSettings,
  FailureGetBlacklistSettings,
  RequestSetBlacklistSettings,
  SuccessSetBlacklistSettings,
  FailureSetBlacklistSettings,
  RequestAptAnalysisStatus,
  SuccessAptAnalysisStatus,
  FailureAptAnalysisStatus,
  RequestDashboardInsights,
  SuccessDashboardInsights,
  FailureDashboardInsights,
  RequestTransferLogs,
  SuccessTransferLogs,
  FailureTransferLogs,
  RequestGetUrlSettings,
  SuccessGetUrlSettings,
  FailureGetUrlSettings,
  RequestSetUrlSettings,
  SuccessSetUrlSettings,
  FailureSetUrlSettings,
  RequestGetUrl2Settings,
  SuccessGetUrl2Settings,
  FailureGetUrl2Settings,
  RequestSetUrl2Settings,
  SuccessSetUrl2Settings,
  FailureSetUrl2Settings,
  RequestGetSandboxSettings,
  SuccessGetSandboxSettings,
  FailureGetSandboxSettings,
  RequestSetSandboxSettings,
  SuccessSetSandboxSettings,
  FailureSetSandboxSettings,
  RequestToggleUrlSettings,
  RequestToggleUrl2Settings,
  RequestGetSpamSettings,
  SuccessGetSpamSettings,
  FailureGetSpamSettings,
  RequestSetSpamSettings,
  SuccessSetSpamSettings,
  FailureSetSpamSettings,
  RequestToggleSpamSettings,
  RequestGetEmailNotificationSettings,
  SuccessGetEmailNotificationSettings,
  FailureGetEmailNotificationSettings,
  RequestSetEmailNotificationSettings,
  SuccessSetEmailNotificationSettings,
  FailureSetEmailNotificationSettings,
  RequestResetSettings,
  SuccessResetSettings,
  FailureResetSettings,
  RequestRepairSettings,
  SuccessRepairSettings,
  FailureRepairSettings,
  RequestGetFileTypeSettings,
  SuccessGetFileTypeSettings,
  FailureGetFileTypeSettings,
  RequestSetFileTypeSettings,
  SuccessSetFileTypeSettings,
  FailureSetFileTypeSettings,
  RequestGetGeneralSettings,
  SuccessGetGeneralSettings,
  FailureGetGeneralSettings,
  RequestSetGeneralSettings,
  SuccessSetGeneralSettings,
  FailureSetGeneralSettings,
  RequestGetCertificateFile,
  SuccessGetCertificateFile,
  FailureGetCertificateFile,
  RequestSetCertificateFile,
  SuccessSetCertificateFile,
  FailureSetCertificateFile,
  RequestGetKeyFile,
  SuccessGetKeyFile,
  FailureGetKeyFile,
  RequestSetKeyFile,
  SuccessSetKeyFile,
  FailureSetKeyFile,
  RequestSendTestEmail,
  SuccessSendTestEmail,
  FailureSendTestEmail,
  RequestGetAlertSettings,
  SuccessGetAlertSettings,
  FailureGetAlertSettings,
  RequestSetAlertSettings,
  SuccessSetAlertSettings,
  FailureSetAlertSettings,
  RequestNextHops,
  SuccessNextHops,
  FailureNextHops,
} = mailGatewaySlice.actions;
